export function formatKes(amount: bigint): string {
  return `KES ${Number(amount).toLocaleString("en-KE")}`;
}

export function timeAgo(nanoseconds: bigint): { label: string; stale: boolean } {
  const ms = Number(nanoseconds / 1_000_000n);
  const diffMs = Date.now() - ms;
  const diffH = diffMs / 1000 / 60 / 60;
  const stale = diffH > 48;
  let label: string;
  if (diffH < 1) label = `${Math.floor(diffH * 60)}m ago`;
  else if (diffH < 24) label = `${Math.floor(diffH)}h ago`;
  else label = `${Math.floor(diffH / 24)}d ago`;
  return { label, stale };
}

export function formatDate(nanoseconds: bigint): string {
  const ms = Number(nanoseconds / 1_000_000n);
  return new Date(ms).toLocaleString("en-KE", {
    timeZone: "Africa/Nairobi",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatCycles(cycles: bigint): string {
  const t = Number(cycles) / 1e12;
  if (t >= 1) return `${t.toFixed(2)}T`;
  const b = Number(cycles) / 1e9;
  if (b >= 1) return `${b.toFixed(1)}B`;
  return `${(Number(cycles) / 1e6).toFixed(0)}M`;
}

import type { ShopHealth } from "./types";

export function daysFromHealth(h: ShopHealth): number {
  if ("Critical" in h) return Number(h.Critical);
  if ("Low" in h) return Number(h.Low);
  if ("Infinite" in h.Healthy) return Infinity;
  return Number((h.Healthy as { Days: bigint }).Days);
}

export function daysLeft(cycles: bigint, burnPerDay: bigint): number {
  if (burnPerDay === 0n) return Infinity;
  return Math.floor(Number(cycles / burnPerDay));
}

export function cyclesColor(days: number): "green" | "yellow" | "red" {
  if (days > 90) return "green";
  if (days > 30) return "yellow";
  return "red";
}

export function shortPrincipal(principal: string): string {
  return principal.length > 20 ? `${principal.slice(0, 20)}…` : principal;
}

export function indexErrorMessage(err: unknown): string {
  if (err && typeof err === "object") {
    if ("InvalidInput" in err) return (err as { InvalidInput: string }).InvalidInput;
    if ("CanisterError" in err) return (err as { CanisterError: string }).CanisterError;
    if ("NotFound" in err) return "Not found";
    if ("NotAuthorized" in err) return "Not authorized";
    if ("NotOwner" in err) return "Not owner";
    if ("Anonymous" in err) return "Not authenticated";
    if ("AlreadyCreating" in err) return "Already creating";
    if ("AlreadyStoreUser" in err) return "Already a store user";
  }
  return "Unknown error";
}
